module.exports = __webpack_public_path__ + "static/media/iiitk_logo2.571a8584.png";